var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetToVehicles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#263238",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 10.969a.98.98 0 0 0 .245.031h8.01c.54 0 .995-.446.995-.995V4h2.75v3H16l2.25 3v3.75h-1.5A2.247 2.247 0 0 1 14.5 16a2.247 2.247 0 0 1-2.25-2.25h-4.5A2.247 2.247 0 0 1 5.5 16a2.247 2.247 0 0 1-2.25-2.25h-1.5v-2.781zm3.75 3.906a1.123 1.123 0 0 1-1.125-1.125c0-.623.502-1.125 1.125-1.125.622 0 1.125.502 1.125 1.125s-.503 1.125-1.125 1.125zm10.125-6.75L17.095 10H13.75V8.125h1.875zm-1.125 6.75a1.123 1.123 0 0 1-1.125-1.125c0-.623.502-1.125 1.125-1.125s1.125.502 1.125 1.125-.502 1.125-1.125 1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.429 6.429H0V10h3.571V8.571H1.43V6.43zM0 3.57h1.429V1.43H3.57V0H0v3.571zm8.571 5H6.43V10H10V6.429H8.571V8.57zM6.43 0v1.429H8.57V3.57H10V0H6.429z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetToVehicles);
export default __webpack_public_path__ + "static/media/Reset-to-Vehicles.a0b2192d94d88761fe1e9f874f64468e.svg";
export { ForwardRef as ReactComponent };